module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product16-9295a863694d90b8ba218d634e6871a0.jpg";